export default "__VITE_ASSET__ulLeyXhB__"